export const MODULES_LESSONS = '/module-lessons'
export const MODULES = '/modules'
export const MODULE_LESSONS = `${MODULES_LESSONS}/:id`
